import { React, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import UserActivity from './UserActivity';
import CreateUserActivity from './CreateUserActivity';
import UpdateUserActivity from './UpdateUserActivity';

function RouterUpdateActivity() {
   

    return (
        <div>
            <Routes>
                <Route path='/' element={<UserActivity />}></Route>
                <Route path='/createactivity' element={<CreateUserActivity />}></Route>
                <Route path='/updateactivity/:id' element={<UpdateUserActivity />}></Route>
            </Routes>
        </div>
    )
}

export default RouterUpdateActivity